import React, { useState } from 'react';
import {
    TextField,
    Button,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';

interface AddEzvizCameraModalProps {
    open: boolean;
    onClose: () => void;
    setNewCamera: React.Dispatch<React.SetStateAction<Camera>>;
}


const AddEzvizCameraModal: React.FC<AddEzvizCameraModalProps> = ({ open, onClose, setNewCamera }) => {
    const [accessToken, setAccessToken] = useState('');
    const [deviceSerial, setDeviceSerial] = useState('');
    const [code, setCode] = useState('');

    const handleClose = () => {
        setAccessToken('');
        setDeviceSerial('');
        setCode('');
        onClose();
    }

    const handleSubmit = async () => {
        try {
            const params = new URLSearchParams({
                accessToken,
                deviceSerial,
                channelNo: '1',
                protocol: '2',
                code,
                expireTime: '62208000',
                type: '1',
                quality: '1',
            });

            const response = await fetch(`https://open.ezvizlife.com/api/lapp/live/address/get?${params.toString()}`, {
                method: 'POST',
            });

            const result = await response.json();
            if (result.code === '200' && result.data?.url) {
                setNewCamera((prev) => ({
                    ...prev,
                    stream_url: result.data.url,
                }));

                onClose();
            } else {
                alert(`Error: ${result.msg || 'Failed to fetch camera URL'}`);
            }
        } catch (err) {
            alert('Error: ' + (err as Error).message);
        }
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Link EZVIZ Camera</DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={1}>
                    <TextField
                        label="Access Token"
                        fullWidth
                        value={accessToken}
                        onChange={(e) => setAccessToken(e.target.value)}
                    />
                    <TextField
                        label="Device Serial"
                        fullWidth
                        value={deviceSerial}
                        onChange={(e) => setDeviceSerial(e.target.value)}
                    />
                    <TextField
                        label="Code"
                        fullWidth
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                <Button variant="contained" onClick={handleSubmit}>Link Camera</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddEzvizCameraModal;